// @vue/component
import LayoutDefault from '@/layouts/LayoutClient.vue'
import { mapActions, mapGetters } from 'vuex'
import QList from '@/components/common/articles/c-list.vue'
import TasksList from '@/components/common/tasks/c-list.vue'
import QListItem from '@/components/common/articles/c-list-item.vue'
import dateTimeMixin from '@/mixins/datetime'
import colorsMixin from '@/mixins/colors'
import cssMixin from '@/mixins/css'
import DoctorProfile from '@/components/doctor/profile.vue'
import { Timer } from 'easytimer.js';
import vueFilePond from "vue-filepond";
import apiConfig from '@/static/apiConfig'

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import FilePondPluginImageTransform from "filepond-plugin-image-transform";
import TokenService from '@/services/token.service'
import FilePondPluginImageEdit from "filepond-plugin-image-edit";
import "filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css";
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageFilter from 'filepond-plugin-image-filter';

import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
import CropperEditor from 'cropperjs';

// Create component
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageEdit,
    FilePondPluginImageExifOrientation,
    FilePondPluginImageFilter
);


export default {
    name: 'Articles',

    components: {
        LayoutDefault,
        FilePond,
        DoctorProfile,
        TasksList,
        QList,
        QListItem,
        TiptapVuetify
    },


    mixins: [dateTimeMixin, colorsMixin, cssMixin],

    props: {},

    data () {
        return {
            extensions: [
                History,
                Blockquote,
                Link,
                Underline,
                Strike,
                Italic,
                ListItem,
                BulletList,
                OrderedList,
                [Heading, {
                    options: {
                        levels: [1, 2, 3]
                    }
                }],
                Bold,
                Code,
                HorizontalRule,
                Paragraph,
                HardBreak
            ],
            rooms: [],
            myFiles: [],
            files: [],
            filter: localStorage.getItem('filterArticles') || 'private',
            filterOptions: [
                {name: 'Все', value: ''},
                {name: 'Новости', name_single: 'Новость', value: 'news'},
                {name: 'Статьи', name_single: 'Статья', value: 'article'},
            ],
            article: {},
            currentDay: 1,
            sessionClock: '',
            filterFlow: 'noPinned',
            filterSection: 'articles',
            filterTabs: 0,
            errorMessage: '',
            saving: false,
            dialogArticle: false,
            validArticleForm: false,
            tmpCode: null,
            waiting: false,
            loading: true,
            isCurrentArticleAccepted: false,
            editingProfileId: false,
            sessionTimer: false,
            roomsLoaded: false,
            sessionActive: true,
            currentArticleId: null,
            currentArticle: null,
            timerStopwatch: null,
            editor: {

                // Called by FilePond to edit the image
                // - should open your image editor
                // - receives file object and image edit instructions
                open: (file, instructions) => {
                    // open editor here
                    console.log(file);
                },

                // Callback set by FilePond
                // - should be called by the editor when user confirms editing
                // - should receive output object, resulting edit information
                onconfirm: (output) => {},

                // Callback set by FilePond
                // - should be called by the editor when user cancels editing
                oncancel: () => {},

                // Callback set by FilePond
                // - should be called by the editor when user closes the editor
                onclose: () => {}
            },
            rules: {
                required: v => !!v || 'обязательное',
                min: v => v.length >= 6 || 'минимум 6 символов',
                email: v => /.+@.+\..+/.test(v) || 'E-mail введен неверно',
                passwordMatch: () => this.user.password === this.passwordConfirm || ('пароли не совпадают'),
            }
        }
    },

    computed: {
        ...mapGetters({
            getChatsList: 'chats/getChatsList',
            getArticlesList: 'articles/getArticlesList',
            getIsUserLoggedIn: 'auth/getIsUserLoggedIn',
            getUserTasks: 'articles/getUserTasks',
            getErrors: 'articles/getErrors',
            getStats: 'dnet/getStats',
            getUserData: 'auth/getUserData',
            getUserProfile: 'auth/getUserProfile',
        }),

        serverOptions: function() {
            return {
                process: {
                    url: apiConfig.url + '/file/save/article/0/' + this.tmpCode,
                    headers: {
                        Authorization: `Bearer ${TokenService.getToken()}`
                    }
                },
                //fetch: null,
                //revert: null
            }
        },


        maxDays: function() {
            let days = 0
            if (this.getArticlesList && this.getArticlesList.length) {
                let acceptArticles = this.getArticlesList.filter(item => item.accepted)
                for (let i = 0; i < acceptArticles.length; i++) {
                    if (acceptArticles[i].duration > days) {
                        days = acceptArticles[i].duration
                    }
                }
            }
            return days
        },
        filteredArticles: function() {
          return this.rooms.filter(item => this.currentUserId == item.dnet_id && (this.filter == 'noreply' ? item.status == 'preparing' : true))

            /*return this.rooms.filter(item => this.currentUserId == item.dnet_id && (this.filter == 'closed' ? item.status == 'closed' : item.status != 'closed'))*/
        },


        openArticles: function() {
          return this.getArticlesList.filter(item => true)
        },
        currentUserId: function() {
            return this.patientId ? this.patientId : (this.getUserData ? this.getUserData.id + '' : '')
        },
        initials() {
            if (this.getUserData) {
                let names = this.getUserData.name.split(' ')
                return names[0].substring(0, 1) + (names.length > 1 ? names[1].substring(0, 1) : '')
            } else {
                return '—'
            }
        },

    },

    /*destroyed() {
        socket.off("connect_error");
        socket.off("private message");
    },*/

    watch: {
        async filter() {
            this.waiting = true
            localStorage.setItem('filterArticles', this.filter)
            await this.fetchArticlesList({type: this.filter})
            await setTimeout(() => {
                this.waiting = false
            }, 200)
        }
    },

    beforeDestroy() {
        this.clearTimeout()
    },


    async created () {
        //this.timerStopwatch = new Timer();
        await this.fetchArticlesList({type: this.filter})
        this.loading = false
        //await this.startSession(true)

        /*this.timerStopwatch.addEventListener('secondsUpdated',  (e) => {
            this.sessionClock = this.timerStopwatch.getTimeValues().toString()
            // $('#basicUsage').html(timer.getTimeValues().toString());
        });*/

        /*socket.auth = { username: this.getUserData.id };
        socket.connect();

        socket.on("private message", ({ content, from }) => {
            console.log('content on PM', content)
            this.$refs.chat.addMessageToChat(content.chat_id, content)
        });*/

        /*await this.fetchStats({
            own: true,
            period: 'all',
            begin: null,
            end: null,
        })*/
    },

    methods: {
        ...mapActions({
            fetchChatsList: 'chats/fetchChatsList',
            fetchArticlesList: 'articles/fetchArticlesList',
            deleteChat: 'chats/deleteChat',
            clearErrors: 'articles/clearErrors',
            saveArticle: 'articles/saveArticle',
            acceptArticle: 'articles/acceptArticle',
            closeChat: 'chats/closeChat',
            refuseChat: 'chats/refuseChat',
        }),

        saveArticleConfirm: async function() {
            const res = await this.$confirm('Сохранить статью?', { title: 'Внимание', icon: '', color: '#f8495a', buttonTrueText: 'Да', buttonFalseText: 'Нет' })
            if (res) {
                this.saving = true
                try {
                    this.article.tmp_code = this.tmpCode
                    this.article.action = 'create_article'
                    await this.saveArticle(this.article)
                    if (this.getErrors.length > 0) {
                        this.$root.$emit('error:show', this.getErrors[0])
                    } else {
                        await this.fetchArticlesList({type: this.filter})
                        this.dialogArticle = false
                    }
                    this.saving = false
                } catch(e) {
                    console.error(e)
                    this.saving = false
                }


            }
        },

        createArticle: function() {
            this.tmpCode = 'xxxxxxxxxx'.replace(/[x]/g, function(c) {
                return (Math.random() * 16 | 0).toString(16)
            })
            this.dialogArticle = true
            this.article = {}
        },

        handleFilePondInit: function () {
            console.log("FilePond has initialized");

            // FilePond instance methods are available on `this.$refs.pond`
        },
        makeArticle: function () {
            console.log("makeArticle");


        },

        async messageBroadcast(content) {
            console.log('messageBroadcast', content)
            socket.emit("private message", {
                content,
                to: content.recipientId,
            });
        },

        async nextDayAndUpdate() {
            await this.nextDay()
            this.$router.go()
        },

        async onAnswered() {
            let room = this.rooms.find(r => r.id == this.currentChatId)
            if (room && room.status == 'preparing' || room.status == 'closed') {
                await this.loadRooms()
            }
        },

        async onArticleSelected(data) {
            console.log('datadata', data)
            this.currentArticleId = data.id;
            this.currentArticle = data;
            this.isCurrentArticleAccepted = data.accepted
        },

        async startSession(check) {
            let session = await this.checkSession(check)
            if (session.found) {
                this.sessionActive = session
                this.clearTimeout()
                this.timerStopwatch.start({
                    startValues: {
                        seconds: session.duration
                    }
                })
                this.sessionTimeout = setTimeout(() => {
                    this.startSession(true)
                }, session.left * 1000 + 1000)
            } else {
                this.clearTimeout()
                this.sessionActive = false
                this.sessionClock = ''
                this.timerStopwatch.reset()
                this.timerStopwatch.stop()
            }
        },

        async finishSessionConfirm() {
            await this.finishSession()
            this.clearTimeout()
            this.sessionActive = false
            this.sessionClock = ''
            this.timerStopwatch.reset()
            this.timerStopwatch.stop()
            await this.fetchStats({
                own: true,
                period: 'all',
                begin: null,
                end: null,
            })
        },

        clearTimeout() {
            if (this.sessionTimer) {
                clearTimeout(this.sessionTimer)
                this.sessionTimer = null
            }
        },

        async loadRooms() {
            await this.fetchChatsList({code: this.$route.params.code})
            const rooms = []
            for (let i = 0; i < this.getChatsList.length; i++) {
                rooms.push(this.getChatsList[i])
            }
            this.rooms = rooms
            this.roomsLoaded = true
        },

        deleteChatConfirm: async function(chatId) {
            const res = await this.$confirm('Delete this article?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.deleteChat(chatId)
                await this.loadRooms()

            }
        },

        closeChatConfirm: async function(chatId) {
            const res = await this.$confirm('Close this article?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.closeChat({chat_id: chatId})
                await this.loadRooms()

            }
        },

        acceptArticleConfirm: async function(articleId) {
            const res = await this.$confirm('Accept this article?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.clearErrors()
                await this.acceptArticle({article_id: articleId})
                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.fetchArticlesList({type: this.filter})
                }

            }
        },

        refuseChatConfirm: async function(chatId) {
            const res = await this.$confirm('Refuse this article?', { title: 'Warning', icon: '', color: '#f8495a', buttonTrueText: 'Yes', buttonFalseText: 'No' })
            if (res) {
                await this.refuseChat(chatId)

                if (this.getErrors.length > 0) {
                    this.$root.$emit('error:show', this.getErrors[0])
                } else {
                    await this.loadRooms()
                }





            }
        },

    }
}
